import z from "zod";
import { PaginationSchema, SvgSchema } from "../common";
import { DistanceSchema } from "./entity";

export const DistanceSchemas = {
  list: PaginationSchema.extend({ distance: z.string().optional() }),

  create: z.object({
    nameEn: z.string().trim().min(3),
    nameAr: z.string().trim().min(3),
    nameTr: z.string().trim().min(3).catch("Name TR"),
    nameFa: z.string().trim().min(3).catch("Name FA"),
    slug: z.string().optional(),
    image: SvgSchema,
  }),

  seed: DistanceSchema.omit({ updatedAt: true, createdAt: true }),

  update: z.object({
    id: z.uuidv7(),
    nameEn: z.string().trim().min(3),
    nameAr: z.string().trim().min(3),
    nameTr: z.string().trim().min(3).catch("Name TR"),
    nameFa: z.string().trim().min(3).catch("Name FA"),
    slug: z.string().optional(),
    image: SvgSchema,
  }),

  delete: z.object({ id: z.uuidv7() }),
};

export type Distance = z.infer<typeof DistanceSchema>;
export type CreateDistance = z.infer<typeof DistanceSchemas.create>;
export type UpdateDistance = z.infer<typeof DistanceSchemas.update>;
